import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import CardLink, { cardLinkImageStyles } from '~components/Card/CardLink';

const AcceleratingResearchCard: React.FC = () => (
  <CardLink to="/accelerating-research" variant="blue" title="Accélérer la recherche">
    <StaticImage src="../../images/accelerating-research-hero.jpg" alt="" style={cardLinkImageStyles} />
  </CardLink>
);

export default AcceleratingResearchCard;
